import { service } from '@/utils/request'

/**
 * 菜单管理相关url
 */
export const menuManageRequst = {
  //获取菜单管理列表
  getMenuList(data) {
    return service({
      url: '/cloud/uac/v1/admin/resource/menuInfoList',
      method: 'get'
    })
  },
  //增加菜单
  addMenu(data) {
    return service({
      url: '/cloud/uac/v1/admin/permission/add',
      method: 'post',
      data: data
    })
  },
  //编辑菜单
  editMenu(params, data) {
    return service({
      url: '/cloud/uac/v1/admin/permission/modify',
      method: 'post',
      params: params,
      data: data
    })
  },
  //删除菜单
  deletMenu(params) {
    return service({
      url: '/cloud/uac/v1/admin/permission/delete',
      method: 'get',
      params: params
    })
  },
  //获取菜单树配置
  getMenuChildTree(params) {
    return service({
      url: '/cloud/uac/v1/admin/resource/menuChildTree',
      method: 'get',
      params: params
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/systemManage/menuManage.js